import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Rows } from '@/components/layout'
import { useSignUp } from '@/components/Providers/SignUpProvider'

import PricingBar from './PricingBar'
import FormBoxLogo from './FormBoxLogo'
import styles from './SignUp.module.scss'

export default function FormBox({ children, gap = 18, withPricingBar = true, withLogo = true, shouldCalculateMargin = true, ...rest }) {
  const [marginTop, setMarginTop] = useState(0)
  const { formHolderHeight, formBoxHeight, setFormBoxHeight, setFormHolderHeight } = useSignUp()
  const wrapperRef = useRef(null)
  const formHolderRef = useRef(null)

  useEffect(() => {
    if (!formHolderHeight || !formBoxHeight || !shouldCalculateMargin) return
    const visibleHeight = Math.min(window.innerHeight, formHolderHeight)
    const margin = Math.floor(0.5 * (visibleHeight - Math.ceil(formBoxHeight)))
    setMarginTop(margin)
  }, [formHolderHeight, formBoxHeight, shouldCalculateMargin])

  useEffect(() => {
    if (!shouldCalculateMargin) return undefined
    const formHolder = document.querySelector(`.${styles.formHolder}`)
    formHolderRef.current = formHolder
    const fn = () => {
      setFormHolderHeight(formHolder?.clientHeight)
      setFormBoxHeight(wrapperRef.current?.clientHeight)
    }
    const resizeObserver = new ResizeObserver(fn)

    requestAnimationFrame(fn)

    window.addEventListener('resize', fn)
    if (wrapperRef.current) resizeObserver.observe(wrapperRef.current)
    return shouldCalculateMargin ? () => {
      window.removeEventListener('resize', fn)
      if (wrapperRef.current) resizeObserver.disconnect()
    } : undefined
  }, [])

  return (
    <Rows
      ref={wrapperRef}
      className={cx(styles.formBox, 'nui-card nui-card--shadow')}
      gap={gap}
      style={shouldCalculateMargin && marginTop >= 0 ? { marginTop } : undefined}
      {...rest}
    >
      {withPricingBar && <PricingBar />}
      {withLogo && <FormBoxLogo />}
      {children}
    </Rows>
  )
}

FormBox.propTypes = {
  children: PropTypes.node.isRequired,
  gap: PropTypes.number,
  withPricingBar: PropTypes.bool,
  withLogo: PropTypes.bool,
}
